import styled from 'styled-components';

export default styled.div`
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    border: 1px solid #eaeaea;
    border-radius: 2px;
    background-color: white;
    box-shadow: 0 2px 4px 0 rgba(215, 215, 215, 0.5);
    margin: 0 15px;
    ${({ stretch }) => stretch && 'height: 100%;'};
`;

export const NoFlexContainer = styled.div``;
